module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-04-67f4b86d17b569bf3c75d98baf22028a.png";